import React from 'react';
var FollowersCountComponent = function FollowersCountComponent(_ref) {
  var followersCount = _ref.followersCount;
  if (!followersCount) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid-item grid-flex margin-none grid-align-center vertical-center-container",
    "data-testid": "followers-count"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-body-medium-bold margin-right-xs palm-margin-right-s",
    "data-testid": "followers-count-number"
  }, followersCount), /*#__PURE__*/React.createElement("span", {
    "data-testid": "followers-count-label"
  }, "Follower"));
};
export var FollowersCount = /*#__PURE__*/React.memo(FollowersCountComponent);